<template>
    <div class="table-responsive visitors-table-container">
        <table
            class="person-visitors-table table table-sm table-bordered table-hover"
        >
            <caption>
                Ingresos de Personas
            </caption>
            <thead class="thead-orange">
                <tr>
                    <th>Visitante</th>
                    <th>Documento Visitante</th>
                    <th>Tipo de visitante</th>
                    <th>Salio (si/no)</th>
                    <th>Minutos Visita</th>
                    <th>Registrado en</th>
                    <th>Destino</th>
                    <th>Persona Visitada</th>
                    <th>Es Visitante</th>
                    <th>Notas</th>
                    <th>Registrado por</th>
                    <th v-if="showDataConsent">Consentimiento de datos</th>
                    <th v-if="showFssc22000" class="text-center">FSSC 22000</th>
                    <th>Fecha Ingreso</th>
                    <th>Fecha Salida</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="entry in data"
                    :key="entry.id"
                    :data-entry="entry.id"
                    :id="`entry_${entry.id}`"
                    class="entry-row"
                    :data-image="
                        !!entry.person && !!entry.person.photo
                            ? entry.person.photo
                            : ''
                    "
                    :data-person="entry.person.name"
                >
                    <td :id="`name-${entry.id}`">{{ entry.person.name }}</td>
                    <td>{{ entry.person.document }}</td>
                    <td>{{ entry.visitor_type.name }}</td>
                    <td>{{ entry.completed | yesno }}</td>
                    <td>{{ entry.duration }}</td>
                    <td>{{ entry.structure.name }}</td>
                    <td>{{ entry.destination.name }}</td>
                    <td>
                        {{
                            !!entry.visited_person
                                ? entry.visited_person.name
                                : ''
                        }}
                    </td>
                    <td>{{ !entry.person.internal | yesno }}</td>
                    <td>{{ entry.notes }}</td>
                    <td>{{ entry.user.name }}</td>
                    <td v-if="showDataConsent" class="text-center align-middle">
                        <img
                            v-if="dataConsentImageSrc(entry.data_consent)"
                            :src="dataConsentImageSrc(entry.data_consent)"
                            alt="Firma consentimiento"
                            class="data-consent-signature-thumb"
                        />
                        <span v-else>—</span>
                    </td>
                    <td v-if="showFssc22000" class="text-center align-middle">
                        <b-btn
                            v-if="entry.form_fssc22000"
                            size="sm"
                            variant="outline-primary"
                            title="Ver formulario FSSC 22000"
                            @click="openFssc22000(entry)"
                        >
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </b-btn>
                        <span v-else>—</span>
                    </td>
                    <td>{{ entry.created_at | datetime }}</td>
                    <td v-if="entry.departure">
                        {{ entry.departure.created_at | datetime }}
                    </td>
                    <td v-else></td>
                </tr>
            </tbody>
        </table>

        <app-pop-up
            id="person-visitor-fssc22000-detail"
            title="Formulario FSSC 22000"
            size="large"
            :on-close="clearSelectedFssc"
        >
            <div slot="body">
                <p v-if="selectedEntry" class="text-muted mb-3">
                    {{ selectedEntry.person.name }} — {{ selectedEntry.person.document }}
                </p>
                <app-form-fssc22000-detail :form="selectedFsscForm" />
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import PopUp from '../../../UI/Controls/PopUp/PopUp.vue'
import FormFssc22000Detail from '../FormFssc22000Detail.vue'

export default {
    components: {
        appPopUp: PopUp,
        appFormFssc22000Detail: FormFssc22000Detail,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        showDataConsent: {
            type: Boolean,
            default: false,
        },
        showFssc22000: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedEntry: null,
            selectedFsscForm: null,
        }
    },
    watch: {
        data(value) {
            this.$nextTick(() => {
                this.createPopOvers()
            })
        },
    },
    methods: {
        openFssc22000(entry) {
            this.selectedEntry = entry
            this.selectedFsscForm = entry.form_fssc22000
            this.$bus.$emit('person-visitor-fssc22000-detail.open')
        },
        clearSelectedFssc() {
            this.selectedEntry = null
            this.selectedFsscForm = null
        },
        createPopOvers() {
            $('.entry-row').each(function() {
                const row = $(this)
                if (!row.data('image')) return
                row.popover({
                    placement: 'top',
                    content:
                        '<img src="' +
                        row.data('image') +
                        '" style="max-width: 100%;" />',
                    html: true,
                    title: row.data('person') || '',
                    trigger: 'hover',
                    container: $(`#name-${row.data('entry')}`)[0],
                })
            })
        },
        dataConsentImageSrc(consent) {
            if (!consent || typeof consent !== 'string') return ''
            const t = consent.trim()
            if (!t) return ''
            if (t.indexOf('data:image/') === 0) return t
            return 'data:image/png;base64,' + t
        },
    },
    mounted() {
        this.createPopOvers()
    },
}
</script>
<style>
.visitors-table-container {
    /* max-width: 70%; */
}
body {
    overflow-x: hidden;
}
.data-consent-signature-thumb {
    max-width: 120px;
    max-height: 48px;
    object-fit: contain;
    vertical-align: middle;
}
</style>
